var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 50 50"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "email_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.5,
  d: "M0 0h20.399v16.875H0z",
  "data-name": "Rectangle 6978"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19636"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M25 0A25 25 0 1 1 0 25 25 25 0 0 1 25 0",
  "data-name": "Path 27388"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19476"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#email_svg__a)",
  "data-name": "Group 19475",
  transform: "translate(15 17)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M4.447 5.004 10.2 9.91l5.68-4.906m-.525 11.051H5.044A4.225 4.225 0 0 1 .819 11.83V5.044A4.225 4.225 0 0 1 5.044.819h10.31a4.225 4.225 0 0 1 4.225 4.225v6.786a4.225 4.225 0 0 1-4.225 4.226Z",
  "data-name": "Path 27330"
}))))));
export { SvgEmail as ReactComponent };
export default __webpack_public_path__ + "static/media/email.5f239e09f971eaf6ce65280abdf22345.svg";